import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUnitByIdApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getUnitById = createAsyncThunk('getUnitById', async (payload) => {
  // console.log('payload', payload);
  return await getUnitByIdApi(payload);
});

const getUnitByIdSlice = createSlice({
  name: 'getUnitById', // Unique Name
  initialState,
  reducers: {
    getUnitByIdReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUnitById.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getUnitById.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getUnitById.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getUnitByIdReset } = getUnitByIdSlice.actions;

export default getUnitByIdSlice.reducer;
